import { ColorSAP, Typography } from "../../ontego-ui";
import { styled } from "@mui/material";

const Styled = {};

Styled.BreadcrumbContainer = styled("div")(() => ({
    width: "fit-content",
    display: "inline-flex",
    alignItems: "center"
}));

Styled.BreadcrumbStackContainer = styled("div")(({ isLast }) => ({
    display: 'flex',
    alignItems: 'center',
    "& svg": isLast ? {
        width: 20,
        height: 20,
        color: ColorSAP.primary[70],
        marginRight: 6,
    } : {
        width: 24,
        height: 24,
        color: ColorSAP.neutral[30],
        marginRight: 8,
    }
}));

Styled.BreadcrumbLabel = styled(Typography)(() => ({
    userSelect: "none",
    color: ColorSAP.primary[100],
    transition: 'all 0.3s ease',
    "&:hover": {
        color: ColorSAP.primary[70],
        transition: 'all 0.3s ease',
    }
}));

Styled.BreadcrumbTypographyHeader = styled(Typography)(() => ({
    userSelect: "none",
    color: ColorSAP.neutral[100],
    transition: 'all 0.3s ease',
    "&:hover": {
        color: ColorSAP.primary[70],
        transition: 'all 0.3s ease',
    },
    marginBottom: -6,
    marginLeft: 28,
}));

Styled.BreadcrumbTextContainer = styled("div")(({ isLast }) => ({
    position: 'relative',
    '&::after': isLast ? {} : {
        content: '""',
        position: 'absolute',
        bottom: -5,
        left: 0,
        width: 0,
        height: 1,
        backgroundColor: 'black',
        transition: 'width 600ms ease',
    },
    '&:hover::after': isLast ? {} : {
        width: '100%',
        left: 0,
    },
}));

export default Styled;
